import api from "../../../../../features/auth/axiosConfig";
import { CustomerDetails } from "../types/salon.types";

export const addCustomer = async (name: string, phone: string) => {
  const { data } = await api.post("/app/v1/pos/customer", {
    Name: name,
    phone_number: phone,
  });
  return data;
};

export const fetchOutstandingBalance = async (customerId: string): Promise<number> => {
  const { data } = await api.get(`/app/v1/pos/customer/${customerId}/balance`);
  return data.balance || 0;
};
